import React, { useState } from 'react';
import ActionButton from '~components/atoms/ActionButton';
import Table from '~components/molecules/Table';
import { useAppSelector } from '~redux/hooks';
import { MetalTypeEnum, TransactionStatusEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';
import * as Styles from './_stockOutTable.module.scss';
import dayjs from 'dayjs';
import ViewSerialNoModal from '~components/molecules/ViewSerialNoModal';

const StockOutTable = () => {
    const {
        Misc: { renderTransactionStatusChip },
    } = UtilFunctions;

    const inventoryStockOuts = useAppSelector(
        state => state.gold.goldInventory.inventoryStockOutListing.stockOuts,
    );
    const isLoading = useAppSelector(state => state.gold.loadings.getStockOutListing);
    const filters = useAppSelector(state => state.gold.goldInventory.inventoryStockOutListing.filters);

    const allProducts = useAppSelector(state => state.gold.allProducts);

    const [serialNoList, setSerialNoList] = useState<string[]>([]);
    const [isSerialNoModalOpen, setIsSerialNoModalOpen] = useState(false);

    const tableHeader = [
        'PRODUCT NAME',
        'AMOUNT',
        'BRANCH NAME',
        'BRANCH CODE',
        'SERIAL NUMBER',
        'STATUS',
        'DATE',
    ];

    const tableData = inventoryStockOuts.map(item => {
        const {
            id,
            productDetails: { productName, productId },
            requestedAmount,
            branchDetails: { branchName, branchCode },
            serialNumbers,
            status,
            createdAt,
        } = item;

        const handleViewSerialNo = () => {
            setIsSerialNoModalOpen(true);
            setSerialNoList(serialNumbers);
        };

        const renderSerialNo = () => (
            <ActionButton key={id} label='View' onClick={handleViewSerialNo} />
        );

        const product = allProducts.find(product => String(product.productId) === productId);

        const isGold = product?.metalType === MetalTypeEnum.Gold;

        return {
            className: isGold ? Styles['gold-row'] : '',

            cells: [
                productName,
                requestedAmount,
                branchName,
                branchCode,
                renderSerialNo(),
                renderTransactionStatusChip(status, TransactionStatusEnum[status]),
                dayjs(createdAt).format('DD/MM/YYYY hh:mm A'),
            ],
        };
    });

    return (
        <>
            <Table header={tableHeader} body={tableData} isLoading={isLoading} />
            <ViewSerialNoModal
                isOpen={isSerialNoModalOpen}
                onClose={() => setIsSerialNoModalOpen(false)}
                serialNo={serialNoList}
            />
        </>
    );
};

export default StockOutTable;
